import { Injectable } from '@angular/core';
import { ValidatorService } from 'src/app/core/validator/validator.service';
import { DepotStockLocation } from '../models/depot-stock-location.model';

@Injectable({
  providedIn: 'root'
})
export class DepotStockLocationValidatorService extends ValidatorService {
  isValid(data: DepotStockLocation) {
    this.errors = [];

    if(!this.isDropdownSupplied(data.accountId)) {
      this.errors.push('accountId');
    }

    if(!this.isDropdownSupplied(data.warehouseLocationId)) {
      this.errors.push('warehouseLocationId');
    }

    return this.errors.length === 0;
  }
}
